import FacebookLogo from 'Shared/icons/logos/facebook.svg';
import { useTranslations } from '@ifixit/i18n/hooks';
import FacebookLogin, { type InitParams } from '@greatsumini/react-facebook-login';
import { Auth } from 'Shared/auth';
import { RecentlyUsedBadge } from './RecentlyUsedBadge';

export function FacebookSSOButton({
   loginHandler,
   setError,
   text,
   recentlyUsed,
}: {
   loginHandler: (response: any) => void;
   setError: (error: string) => void;
   text: string;
   recentlyUsed?: boolean;
}) {
   const t = useTranslations('Login');
   if (!App.facebookLoginEnabled) {
      return null;
   }

   return (
      <FacebookLogin
         appId={App.facebookAppId}
         initParams={{
            // FacebookLogin doesn't include 25.0 in the hardcoded types, so cast
            version: 'v25.0' as InitParams['version'],
            cookie: true,
         }}
         onSuccess={() => {
            (Auth as any).clearCookies();
            (Auth as any).sendFacebookLogin(loginHandler);
         }}
         onFail={(_error: any) => {
            setError(t('unableToCompleteFacebookLogin'));
         }}
         render={(renderProps: any) => (
            <div
               id="facebookLogin"
               data-mobile-appid="facebookLogin"
               className="cursor-pointer"
               onClick={renderProps.onClick}
            >
               <button className="button-outline button-lg w-full gap-2 z-1">
                  <FacebookLogo className="size-6.5" />
                  {text}
               </button>
               {recentlyUsed && <RecentlyUsedBadge />}
            </div>
         )}
      />
   );
}
